module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"start":"Start","back":"Back","close":"Close","not found":"Not found","notFoundMsg":"Page is still under constuction!","related topics":"Related topics"},"de":{"start":"Start","back":"Zurück","close":"Schliessen","not found":"Nicht gefunden","notFoundMsg":"Seite ist in Bearbeitung!","related topics":"Verwandte Themen"}}')
  delete Component.options._Ctor
}
